import { Alert, Snackbar } from '@mui/material'
import { FC } from 'react'
import styled from 'styled-components'

type QRCodeContainerProps = {
  isExtended?: boolean
}

export const QRCodeLayout = styled.div`
  display: grid;
  grid-template-columns: 277px 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 20px;
`

export const QRCodeContainer = styled('div')<QRCodeContainerProps>`
  width: 275px;
  height: ${({ isExtended }) => (isExtended ? '320px' : '275px')};
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
`

export const QRCodeText = styled.p`
  text-align: center;
  color: #000;
  font-family: Montserrat;
  font-weight: bold;
  font-size: 25px;
  margin: 0;
  margin-top: 15px;
`

export const SelectContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 10px;
  width: 100%;
  align-self: flex-start;
`

export const DisclaimerText = styled.p`
  color: #000;
  text-align: center;
  padding: 20px;
  font-size: 20px;
`

export const SelectContainerBottomAligned = styled(SelectContainer)`
  align-self: flex-end;
`

type MessageCopiiedToasterProps = {
  isOpen: boolean
  onClose: () => void
}
export const MessageCopiiedToaster: FC<MessageCopiiedToasterProps> = ({
  isOpen = false,
  onClose
}) => (
  <Snackbar
    open={isOpen}
    autoHideDuration={2000}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    message='Link is coppied!'
    color='success'
    onClose={onClose}
  >
    <Alert onClose={onClose} severity='success' variant='filled' sx={{ width: '100%' }}>
      Link is coppied!
    </Alert>
  </Snackbar>
)
